import { batch, connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking';
import { actions as filterMenuActions } from '../../FilterMenu/modules/slice';
import { FilterList } from '../components/FilterList';
import { onViewResultsClick } from '../modules/actions';
import {
  selectFiltersWithFilterOptionsCount,
  selectFiltersWithFilterOptionsCountWithoutSortFilter,
  selectIsUsingCollapsibleFiltersFeature,
  selectTotalSelectedFilterOptionsCount,
} from '../modules/selectors';
import { actions as filterActions } from '../modules/slice';
import {
  FILTER_LIST_ITEM_VISIBILITY_NAME,
  FilterListItemImpressionActionPayload,
} from '../tracking/events';

interface FilterListContainerProps {
  removeSortFilter?: boolean;
}

export const mapStateToProps = (
  state: ReduxApplicationState,
  { removeSortFilter }: FilterListContainerProps,
) => ({
  isLoading: state.products.isLoading,
  filters: removeSortFilter
    ? // This is needed to remove the sort filter from the list when rendering the filters on large screen. Sort filter should only show on MW & TA.
      selectFiltersWithFilterOptionsCountWithoutSortFilter(state)
    : selectFiltersWithFilterOptionsCount(state),
  totalProducts: state.products.totalProducts,
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
  error: state.products.error,
  isUsingExpandableFilters: selectIsUsingCollapsibleFiltersFeature(state),
});

export const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onCloseFilters: () => dispatch(filterActions.closeModal()),
  onViewResults: () => {
    batch(() => {
      dispatch(onViewResultsClick());
      dispatch(filterActions.closeModal());
    });
  },
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
  onFilterListItemVisibility: (filterUid: string) =>
    dispatch(
      visibilityTrackingActions.sectionVisible<FilterListItemImpressionActionPayload>({
        sectionName: FILTER_LIST_ITEM_VISIBILITY_NAME,
        filterUid,
      }),
    ),
});

export const FilterListContainer = connect(mapStateToProps, mapDispatchToProps)(FilterList);
